export const ANIMAL_NAMES = [
  "Albatross",
  "Ant",
  "Anteater",
  "Antelope",
  "Aphid",
  "Armadillo",
  "Badger",
  "Barbel",
  "Bat",
  "Bear",
  "Beaver",
  "Bee",
  "Beetle",
  "Biddy",
  "Blackbird",
  "Blindworm",
  "Boa",
  "Bullock",
  "Bumblebee",
  "Camel",
  "Canary",
  "Carp",
  "Caterpillar",
  "Chameleon",
  "Chimpanzee",
  "Cockroach",
  "Cod",
  "Copperhead",
  "Coral Snake",
  "Cottonmouth",
  "Crab",
  "Crocodile",
  "Crow",
  "Cuckoo",
  "Dachshund",
  "Dolphin",
  "Dove",
  "Dragonfly",
  "Duck",
  "Eagle",
  "Earthworm",
  "Eel",
  "Elephant",
  "Falcon",
  "Finch",
  "Flamingo",
  "Flea",
  "Fly",
  "Fox",
  "Frog",
  "Frogspawn",
  "Gadfly",
  "Gazelle",
  "Gecko",
  "Gerbil",
  "Giraffe",
  "Goat",
  "Goldfish",
  "Goose",
  "Grasshopper",
  "Guinea Pig",
  "Gull",
  "Haddock",
  "Halibut",
  "Hamster",
  "Hare",
  "Harvestman",
  "Hawk",
  "Hedgehog",
  "Hog",
  "Horse",
  "Hyena",
  "Iguana",
  "Jackdaw",
  "Jay",
  "Jellyfish",
  "Kestrel",
  "Kookaburra",
  "Ladybug",
  "Larva",
  "Leech",
  "Lion",
  "Lizard",
  "Llama",
  "Lobster",
  "Lynx",
  "Maggot",
  "Mallard",
  "Mammoth",
  "Marmot",
  "Midge",
  "Millipede",
  "Mink",
  "Mole",
  "Mongoose",
  "Moth",
  "Mouse",
  "Mule",
  "Newt",
  "Nightingale",
  "Nuthatch",
  "Nymph",
  "Ostrich",
  "Otter",
  "Owl",
  "Panda",
  "Parakeet",
  "Parrot",
  "Peacock",
  "Pelican",
  "Penguin",
  "Perch",
  "Pheasant",
  "Pig",
  "Pigeon",
  "Pike",
  "Piranha",
  "Plaice",
  "Platypus",
  "Polar Bear",
  "Polecat",
  "Pony",
  "Porcupine",
  "Prairie Dog",
  "Puma",
  "Python",
  "Rat",
  "Raven",
  "Ray",
  "Red Admiral",
  "Reindeer",
  "Rhinoceros",
  "Robin",
  "Rooster",
  "Roundworm",
  "Salamander",
  "Salmon",
  "Saurian",
  "Sawfish",
  "Scallop",
  "Scorpion",
  "Seal",
  "Shark",
  "Sheep",
  "Shrimp",
  "Sidewinder",
  "Silkworm",
  "Skunk",
  "Sloth",
  "Slug",
  "Snail",
  "Snake",
  "Sparrow",
  "Spider",
  "Squirrel",
  "Stork",
  "Swallow",
  "Swallowtail",
  "Swan",
  "Swift",
  "Tadpole",
  "Tapeworm",
  "Tarantula",
  "Tiger",
  "Tit",
  "Toad",
  "Tortoise",
  "Trout",
  "Turkey",
  "Turtle",
  "Vulture",
  "Wasp",
  "Weasel",
  "Whale",
  "Wolf",
  "Woodpecker",
  "Wren",
  "Zebra",
  "Anaconda",
  "Aardvark",
  "Baboon",
  "Barracuda",
  "Bison",
  "Buffalo",
  "Capybara",
  "Cheetah",
  "Chipmunk",
  "Cougar",
  "Coyote",
  "Deer",
  "Donkey",
  "Fennec Fox",
  "Ferret",
  "Gorilla",
  "Heron",
  "Hippopotamus",
  "Hornet",
  "Hummingbird",
  "Jaguar",
  "Koala",
  "Kraken",
  "Lemur",
  "Leopard",
  "Macaw",
  "Meerkat",
  "Moose",
  "Octopus",
  "Okapi",
  "Opossum",
  "Orca",
  "Panther",
  "Quokka",
  "Raccoon",
  "Rattlesnake",
  "Sea Lion",
  "Serval",
  "Starling",
  "Tuna",
  "Walrus",
  "Wolverine",
  "Yak",
  "Alligator",
  "Alpaca",
  "Auk",
  "Bonobo",
  "Caracal",
  "Cassowary",
  "Chinchilla",
  "Cormorant",
  "Dingo",
  "Dromedary",
  "Emu",
  "Fossa",
  "Frigatebird",
  "Gaur",
  "Gibbon",
  "Gnu",
  "Groundhog",
  "Grouse",
  "Hyrax",
  "Ibex",
  "Kingfisher",
  "Kudu",
  "Loris",
  "Manatee",
  "Mandrill",
  "Manta Ray",
  "Mantis",
  "Myna",
  "Narwhal",
  "Numbat",
  "Ocelot",
  "Oryx",
  "Porpoise",
  "Puffin",
  "Quail",
  "Red Panda",
  "Sable",
  "Saiga",
  "Sardine",
  "Sifaka",
  "Skylark",
  "Snow Leopard",
  "Stoat",
  "Swordfish",
  "Tamarin",
  "Tapir",
  "Tarsier",
  "Tern",
  "Toucan",
  "Urial",
  "Vicuna",
  "Wallaby",
  "Warthog",
  "Wildebeest",
  "Wombat",
  "Zebu",
  "Bobcat",
  "Budgerigar",
  "Caiman",
  "Civet",
  "Coati",
  "Curlew",
  "Dugong",
  "Egret",
  "Eland",
  "Firefly",
  "Gannet",
  "Goldfinch",
  "Hammerhead",
  "Harrier",
  "Hoopoe",
  "Impala",
  "Jerboa",
  "Kinkajou",
  "Kiwi",
  "Lemming",
  "Macaque",
  "Mackerel",
  "Magpie",
  "Marlin",
  "Marten",
  "Muskox",
  "Oriole",
  "Pangolin",
  "Partridge",
  "Pika",
  "Plover",
  "Rook",
  "Sandpiper",
  "Shrike",
  "Snipe",
  "Sunbird",
  "Tarpon",
  "Waxwing",
  "Whippet",
  "Archerfish",
  "Avocet",
  "Axolotl",
  "Barramundi",
  "Bittern",
  "Blackbuck",
  "Bluebird",
  "Boa Constrictor",
  "Caribou",
  "Cavy",
  "Coelacanth",
  "Cuttlefish",
  "Dhole",
  "Drongo",
  "Geoduck",
  "Goshawk",
  "Guppy",
  "Hake",
  "Jackal",
  "Kite",
  "Langur",
  "Lapwing",
  "Lark",
  "Limpet",
  "Lobefin",
  "Moorhen",
  "Mudskipper",
  "Nautilus",
  "Needlefish",
  "Osprey",
  "Peafowl",
  "Piranha Fish",
  "Pronghorn",
  "Ptarmigan",
  "Puffadder",
  "Rhea",
  "Roadrunner",
  "Seahorse",
  "Smelt",
  "Snowy Owl",
  "Springbok",
  "Stingray",
  "Treefrog",
  "Triggerfish",
  "Wildcat",
  "Woodlark",
  "Woolly Bear",
  "Anole",
  "Bream",
  "Bustard",
  "Caracara",
  "Chukar",
  "Cicada",
  "Cobra",
  "Conch",
  "Darter",
  "Echidna",
  "Flounder",
  "Galago",
  "Gavial",
  "Gerenuk",
  "Grackle",
  "Grebe",
  "Grouper",
  "Guillemot",
  "Hartebeest",
  "Jacana",
  "Kakapo",
  "Kinglet",
  "Kittiwake",
  "Koel",
  "Lamprey",
  "Marmoset",
  "Mockingbird",
  "Monkfish",
  "Needletail",
  "Nightjar",
  "Oilbird",
  "Petrel",
  "Pipit",
  "Potoo",
  "Prawn",
  "Remora",
  "Skimmer",
  "Sora",
  "Spadefoot",
  "Spoonbill",
  "Tanager",
  "Teal",
  "Thrush",
  "Tinamou",
  "Turnstone",
  "Uakari",
  "Whimbrel",
  "Whitefish",
  "Wigeon",
];

export const ANIMAL_ADJECTIVES = [
  "Adequate",
  "Affable",
  "Affectionate",
  "Aggressive",
  "Banal",
  "Bold",
  "Boring",
  "Brave",
  "Capricious",
  "Carefree",
  "Careful",
  "Caring",
  "Cheerful",
  "Clever",
  "Cocky",
  "Confiding",
  "Cowardly",
  "Cultural",
  "Cunning",
  "Curious",
  "Cynical",
  "Dashing",
  "Desperate",
  "Dexterous",
  "Diplomatic",
  "Distrustful",
  "Dynamic",
  "Easy",
  "Educated",
  "Emotional",
  "Envious",
  "Evil",
  "Fair",
  "Fanatical",
  "Frowning",
  "Gambling",
  "Generous",
  "Greedy",
  "Hardworking",
  "Hardy",
  "Impudent",
  "Incorruptible",
  "Indifferent",
  "Ingenious",
  "Insidious",
  "Lazy",
  "Loving",
  "Lucky",
  "Modest",
  "Naive",
  "Nasty",
  "Nervous",
  "Noisy",
  "Orderly",
  "Picky",
  "Polite",
  "Positive",
  "Proud",
  "Punctual",
  "Quiet",
  "Reliable",
  "Responsible",
  "Right",
  "Romantic",
  "Secretive",
  "Selfish",
  "Sincere",
  "Slow",
  "Smart",
  "Smiling",
  "Sneaky",
  "Stingy",
  "Strict",
  "Strong-willed",
  "Stubborn",
  "Sullen",
  "Sure",
  "Suspicious",
  "Tedious",
  "Tender",
  "Thoughtful",
  "Timid",
  "Touchy",
  "Unhappy",
  "Unique",
  "Unpredictable",
  "Vulgar",
  "Vulnerable",
  "Wise",
  "Witty",
  "Agile",
  "Alert",
  "Ambitious",
  "Artful",
  "Astute",
  "Balanced",
  "Blazing",
  "Breezy",
  "Bright",
  "Calm",
  "Charming",
  "Daring",
  "Dazzling",
  "Decisive",
  "Delightful",
  "Eager",
  "Elegant",
  "Fearless",
  "Fierce",
  "Focused",
  "Gentle",
  "Graceful",
  "Heroic",
  "Humble",
  "Inventive",
  "Jolly",
  "Keen",
  "Loyal",
  "Mighty",
  "Nimble",
  "Noble",
  "Playful",
  "Quick",
  "Radiant",
  "Rapid",
  "Resilient",
  "Robust",
  "Sharp",
  "Shiny",
  "Silent",
  "Steady",
  "Swift",
  "Vibrant",
  "Vigilant",
  "Wild",
  "Zesty",
  "Adaptable",
  "Astonishing",
  "Blunt",
  "Brisk",
  "Candid",
  "Composed",
  "Crafty",
  "Diligent",
  "Earnest",
  "Energetic",
  "Exact",
  "Flexible",
  "Gallant",
  "Genuine",
  "Gleaming",
  "Grounded",
  "Handy",
  "Honest",
  "Intense",
  "Intrepid",
  "Jaunty",
  "Jovial",
  "Levelheaded",
  "Lively",
  "Lucid",
  "Methodical",
  "Meticulous",
  "Observant",
  "Patient",
  "Perceptive",
  "Persistent",
  "Plucky",
  "Poised",
  "Polished",
  "Precise",
  "Prompt",
  "Proudhearted",
  "Prudent",
  "Rational",
  "Refined",
  "Resourceful",
  "Rugged",
  "Sensible",
  "Sleek",
  "Solid",
  "Spirited",
  "Stalwart",
  "Steadfast",
  "Stoic",
  "Tactful",
  "Tenacious",
  "Thorough",
  "Upbeat",
  "Valiant",
  "Versatile",
  "Vigorous",
  "Warm",
  "Wary",
  "Whimsical",
  "Youthful",
  "Zealous",
  "Able",
  "Adept",
  "Aerial",
  "Ardent",
  "Attentive",
  "Audacious",
  "Avid",
  "Beaming",
  "Bouncy",
  "Brainy",
  "Buoyant",
  "Centered",
  "Clear-eyed",
  "Coolheaded",
  "Crisp",
  "Driven",
  "Earthy",
  "Efficient",
  "Elastic",
  "Enduring",
  "Fair-minded",
  "Fast",
  "Fervent",
  "Fleet",
  "Fluid",
  "Free",
  "Fresh",
  "Gritty",
  "Hearty",
  "Helpful",
  "Impartial",
  "Kinetic",
  "Lean",
  "Mellow",
  "Merry",
  "Neat",
  "Nifty",
  "Objective",
  "Openhearted",
  "Prime",
  "Ready",
  "Receptive",
  "Rousing",
  "Sage",
  "Spry",
  "Stable",
  "Staunch",
  "True",
  "Trusty",
  "Unshaken",
  "Upright",
  "Vivid",
  "Watchful",
  "Wholehearted",
  "Zippy",
  "Acute",
  "Adventurous",
  "Agreeable",
  "Amicable",
  "Animated",
  "Assertive",
  "Brilliant",
  "Cordial",
  "Creative",
  "Dapper",
  "Dependable",
  "Devoted",
  "Discerning",
  "Equable",
  "Farsighted",
  "Feisty",
  "Glowing",
  "Golden",
  "Harmonious",
  "Imaginative",
  "Insightful",
  "Jubilant",
  "Kindly",
  "Luminous",
  "Mindful",
  "Motivated",
  "Natural",
  "Neighborly",
  "Optimistic",
  "Original",
  "Peppy",
  "Placid",
  "Pliable",
  "Reactive",
  "Resolute",
  "Responsive",
  "Selfless",
  "Skillful",
  "Sociable",
  "Sparkling",
  "Sturdy",
  "Sunny",
  "Supportive",
  "Tidy",
  "Unbiased",
  "Unflappable",
  "Upstanding",
  "Willing",
  "Worldly",
  "Accomplished",
  "Accurate",
  "Adapted",
  "Adorable",
  "Altruistic",
  "Approachable",
  "Apt",
  "Articulate",
  "Blooming",
  "Capable",
  "Charitable",
  "Concise",
  "Considerate",
  "Convincing",
  "Courageous",
  "Courteous",
  "Deliberate",
  "Distinctive",
  "Empathetic",
  "Enthusiastic",
  "Even-tempered",
  "Exacting",
  "Expressive",
  "Faithful",
  "Favorable",
  "Frank",
  "Glorious",
  "Good-natured",
  "Ideal",
  "Illustrious",
  "Judicious",
  "Kindhearted",
  "Learned",
  "Logical",
  "Magnanimous",
  "Measured",
  "Notable",
  "Persuasive",
  "Proactive",
  "Purposeful",
  "Striking",
  "Systematic",
  "Trustworthy",
  "Uncommon",
  "Valorous",
  "Well-spoken",
  "Winsome",
];

export function generateRandomName(): string {
  const randomAnimalName = Math.floor(Math.random() * ANIMAL_NAMES.length);
  const randomAnimalAdjective = Math.floor(
    Math.random() * ANIMAL_ADJECTIVES.length
  );
  return (
    ANIMAL_ADJECTIVES[randomAnimalAdjective] +
    " " +
    ANIMAL_NAMES[randomAnimalName]
  );
}
